<template>
  <div
    :class="
      $route.meta.hidden ? 'row  breadcrumb-bg' : 'row  breadcrumb-bg p-xs'
    "
    style="margin: 0"
  >
    <img src="@/assets/img/logo.png" alt="" style="width: 135px; height: 48px;">
    <!-- <span class="bread-title">{{routeMenu.name}}</span> -->
    <!-- <img :src="require('@/assets/img/icon/bread-nav-icon.png')" width="18" height="18" alt="" /> -->
    <!-- <div>
      <ol class="breadcrumb">
        <template v-for="(level, index) in levelMenu" :key="index">
          <li v-if="level.name !== $route.name">
            <router-link v-if="level.path" :to="level.path">{{
              level.name
            }}</router-link>
            <router-link v-else :to="$route.path">{{ level.name }}</router-link>
          </li>
        </template>

        <li class="active" v-if="!$route.meta.hidden">
          <span @click="reload" style="cursor: pointer">{{
            routeMenu.name
          }}</span>
        </li>
      </ol>
    </div> -->
    <div class="shopSel" v-if="showStoreSelector">
      <el-select
        v-model="curStoreIndex"
        placeholder="选择门店"
        @change="handleChangeShop"
      >
        <el-option
          v-for="(item, index) in storeInfos"
          :key="'shop_' + item.storeCode"
          :label="item.storeName"
          :value="index"
        ></el-option>
      </el-select>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import menuModule from "@/store/modules/menu2";

export default {
  name: "breadcrumb",
  data() {
    return {
      levelMenu: [],
      menu: [],
      defaultPath: "/",
      routeMenu: {},
      curStoreIndex: '',
      storeInfos: [],
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.common.user
    }),
    // 是否可以选择门店
    showStoreSelector() {
      let show = this.userInfo.userType == 4 || this.userInfo.userType == 5
      if (!show) {
        localStorage.removeItem('curShop')
      }
      return show
    },
  },
  watch: {
    $route(to, from) {
      this._returnLevel(this.menu, to, []);
    },
  },
  beforeMount() {
    this.menu = "menu" in localStorage && localStorage.menu !== "" ? JSON.parse(localStorage.menu) : [];
    this.updateMenu(this.menu);
    this._returnLevel(this.menu, this.$route, []);
    this.getHomePagePath();
    if (this.showStoreSelector) {
      this.getStoreInfos();
    }
  },
  created() {
    console.log(this.levelMenu)
    this.$eventBus.on('update-global-shop', () => {
      if (this.showStoreSelector) {
        this.getStoreInfos();
      }
    })
  },
  beforeUnmount() {
    this.$eventBus.off('update-global-shop')
  },
  methods: {
    ...mapActions(["fetchData"]),
    reload() {
      location.reload();
    },
    _returnLevel(levels, level, parent) {
      for (var i = 0; i < levels.length; i++) {
        if (levels[i].children) {
          parent.push(levels[i]);
          if (this._returnLevel(levels[i].children, level, parent)) {
            return true;
          } else {
            parent.pop();
            // continue;
          }
        }
        if (levels[i].path === level.path) {
          this.levelMenu = parent;
          this.routeMenu = levels[i];
          return true;
        }
      }
      return false;
    },
    //判断首页路径
    getHomePagePath() {
      let perms = "perms" in localStorage && localStorage.perms !== "" ? JSON.parse(localStorage.perms) : [];
      let status = false;
      perms.map((item) => {
        if (item.path === "/") {
          status = true;
        }
      });
      if (!status) {
        this.defaultPath = "/workingTable";
      }
    },
    updateMenu(menu) {
      menu.forEach((item) => {
        if (!item.children) {
          if (item.path === "/spy/menu") {
            item.children = JSON.parse(localStorage.spyToolsMenu);
          }
          if (item.children) {
            this.updateMenu(item.children);
          } else {
            menuModule.routes.forEach((route) => {
              if (route.path === item.path && route.children) {
                item.children = route.children;
              }
            });
          }
        } else if (item.children && item.children.length) {
          this.updateMenu(item.children);
        }
      });
    },
    // 处理门店切换
    handleChangeShop() {
      this.$eventBus.emit('change-shop', this.storeInfos[this.curStoreIndex])
      localStorage.setItem('curShop', JSON.stringify(this.storeInfos[this.curStoreIndex]))
    },
    // 获取门店
    getStoreInfos() {
      let params = {};
      let url = "SAAS.STORE_LIST";
      this.fetchData({ url, method: "get", params })
        .then((res) => {
          this.storeInfos = res.data || [];
          let localShop = localStorage.getItem("curShop")
          let curShopInfo = {}
          if (localShop && localShop !== undefined && localShop !== 'undefined' && typeof localShop === 'string') {
            curShopInfo = JSON.parse(localShop)
          }

          this.curStoreIndex = ''
          if (curShopInfo.id && this.storeInfos.length) {
            for (let i = 0; i < this.storeInfos.length; i++) {
              if (this.storeInfos[i].id == curShopInfo.id) {
                this.curStoreIndex = i;
                break
              }
            }
          }

          if (this.curStoreIndex === '' && this.storeInfos.length) {
            this.curStoreIndex = 0
          }

          this.handleChangeShop()
        })
    },
  },
};
</script>

<style lang="less">
.breadcrumb-bg {
  display: flex;
  align-items: center;
  .bread-title{font-size: 22px;padding-right: 30px;}
  .breadcrumb {
    background:none;
    margin-bottom: 0;
    > li{
      font-size: @font-small;
      a {
        color: #c4c4c4;
      }
      &.active {
        color:#000;
      }
    }
  }
  .shopSel {
    margin-left: 40px;
    .el-select .select-trigger .el-input .el-input__inner {
      width: 195px;
      height: 42px !important;
      background-color: #f5f5f5;
      border-radius: 6px;
      border:none;
      font-size: 18px;
      color: #000;
      font-weight: bold;
    }
  }
}
</style>
